module.exports = __webpack_public_path__ + "static/img/anxun11.1532c6a2.png";